import { PasswordResetComponent } from './password-reset/password-reset.component'
import { RequestPasswordResetComponent } from './request-password-reset/request-password-reset.component'
import { GuestGuard } from './../../guards/guest.guard'
import { AuthLayoutComponent } from '@components/auth-layout/auth-layout.component'
import { Routes } from '@angular/router'
import { LoginComponent } from './login/login.component'

export const authRoutes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      { path: 'password-reset/:token', component: PasswordResetComponent },
    ],
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    canActivate: [GuestGuard],
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'password-reset', component: RequestPasswordResetComponent },
    ],
  },
]
